var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EncryptionHandler } from "./encryption-handler";
var SecurityHandler = /** @class */ (function () {
    function SecurityHandler() {
        this.database = 'firefile';
        this.store = 'keys';
        this.textEncoder = new TextEncoder();
        this.numIterations = 500000; // (5-10 sec compution time)
        this.derivedKeyLengthBits = 256; // 32 Bytes
        this.ivLength = 16;
        this.saltLength = 16;
        this.randomKeyLength = 16;
    }
    SecurityHandler.prototype.encryptKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.encryptWithMasterKey(key)];
                    case 1:
                        encryptedKey = _a.sent();
                        return [2 /*return*/, encryptedKey];
                }
            });
        });
    };
    SecurityHandler.prototype.decryptKey = function (encryptedKey) {
        return __awaiter(this, void 0, void 0, function () {
            var decryptedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decryptWithMasterKey(encryptedKey)];
                    case 1:
                        decryptedKey = _a.sent();
                        return [2 /*return*/, decryptedKey];
                }
            });
        });
    };
    SecurityHandler.prototype.decryptKeyString = function (encryptedKeyStr) {
        return __awaiter(this, void 0, void 0, function () {
            var keyEnc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keyEnc = SecurityHandler.stringToArrayBuffer(atob(encryptedKeyStr));
                        return [4 /*yield*/, this.decryptKey(keyEnc)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SecurityHandler.prototype.decryptString = function (str, key) {
        return __awaiter(this, void 0, void 0, function () {
            var ab, iv, data, encryptionHandler, dataDec;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ab = SecurityHandler.stringToArrayBuffer(atob(str));
                        iv = new Uint8Array(ab.slice(0, 16));
                        return [4 /*yield*/, new Response(ab.slice(16)).blob()];
                    case 1:
                        data = _a.sent();
                        encryptionHandler = EncryptionHandler.getDecryptor(iv);
                        return [4 /*yield*/, encryptionHandler.setKey(key)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, encryptionHandler.decryptBlob(data)];
                    case 3:
                        dataDec = _a.sent();
                        return [2 /*return*/, String.fromCharCode.apply(null, new Uint8Array(dataDec))];
                }
            });
        });
    };
    SecurityHandler.prototype.getRandomKey = function () {
        return this.generateRandomString(this.randomKeyLength);
    };
    SecurityHandler.prototype.encryptWithMasterKey = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, derivedKey, iv, encoded, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        salt = this.generateSalt();
                        return [4 /*yield*/, this.deriveKey(salt)];
                    case 1:
                        derivedKey = _a.sent();
                        iv = crypto.getRandomValues(new Uint8Array(this.ivLength));
                        return [4 /*yield*/, crypto.subtle.encrypt({
                                name: 'AES-GCM',
                                iv: iv
                            }, derivedKey, new TextEncoder().encode(value))];
                    case 2:
                        encoded = _a.sent();
                        tmp = new Uint8Array(iv.byteLength + salt.byteLength + encoded.byteLength);
                        tmp.set(iv, 0);
                        tmp.set(salt, iv.byteLength);
                        tmp.set(new Uint8Array(encoded), iv.byteLength + salt.byteLength);
                        return [2 /*return*/, tmp.buffer];
                }
            });
        });
    };
    SecurityHandler.prototype.decryptWithMasterKey = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, derivedKey, iv, decrypted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        salt = new Uint8Array(value.slice(this.ivLength, this.ivLength + this.saltLength));
                        return [4 /*yield*/, this.deriveKey(salt)];
                    case 1:
                        derivedKey = _a.sent();
                        iv = new Uint8Array(value.slice(0, this.ivLength));
                        return [4 /*yield*/, crypto.subtle.decrypt({
                                name: 'AES-GCM',
                                iv: iv
                            }, derivedKey, new Uint8Array(value.slice(this.ivLength + this.saltLength)))];
                    case 2:
                        decrypted = _a.sent();
                        return [2 /*return*/, new TextDecoder().decode(decrypted)];
                }
            });
        });
    };
    SecurityHandler.prototype.deriveKey = function (salt) {
        return __awaiter(this, void 0, void 0, function () {
            var masterKey, derivedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMasterKey()];
                    case 1:
                        masterKey = _a.sent();
                        return [4 /*yield*/, crypto.subtle.deriveKey({
                                name: 'PBKDF2',
                                salt: salt,
                                iterations: this.numIterations,
                                hash: 'SHA-256'
                            }, masterKey, {
                                name: 'AES-GCM',
                                length: this.derivedKeyLengthBits
                            }, true, ['encrypt', 'decrypt'])];
                    case 2:
                        derivedKey = _a.sent();
                        return [2 /*return*/, derivedKey];
                }
            });
        });
    };
    SecurityHandler.prototype.generateSalt = function () {
        return crypto.getRandomValues(new Uint8Array(16));
    };
    SecurityHandler.prototype.saveKeys = function (masterKey, authKey) {
        return __awaiter(this, void 0, void 0, function () {
            var database;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDatabase(this.database)];
                    case 1:
                        database = _a.sent();
                        return [4 /*yield*/, this.addObject(database, this.store, {
                                key: 'masterKey',
                                value: masterKey
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.addObject(database, this.store, {
                                key: 'authKey',
                                value: authKey
                            })];
                    case 3:
                        _a.sent();
                        database.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    SecurityHandler.prototype.clearKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var database;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDatabase(this.database)];
                    case 1:
                        database = _a.sent();
                        return [4 /*yield*/, this.deleteObject(database, this.store, 'masterKey')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.deleteObject(database, this.store, 'authKey')];
                    case 3:
                        _a.sent();
                        database.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    SecurityHandler.prototype.getMasterKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var database, masterKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDatabase(this.database)];
                    case 1:
                        database = _a.sent();
                        return [4 /*yield*/, this.getObject(database, this.store, 'masterKey')];
                    case 2:
                        masterKey = _a.sent();
                        return [2 /*return*/, masterKey];
                }
            });
        });
    };
    SecurityHandler.prototype.openDatabase = function (name) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var request = indexedDB.open(name, 1);
            request.onerror = function (event) { return reject(event); };
            request.onsuccess = function (event) { return resolve(request.result); };
            request.onupgradeneeded = function (event) {
                _this.createObjectStore(request.result, _this.store);
            };
        });
    };
    SecurityHandler.prototype.createObjectStore = function (database, store) {
        if (!database.objectStoreNames.contains(store)) {
            database.createObjectStore(store);
        }
    };
    SecurityHandler.prototype.addObject = function (database, store, object) {
        return new Promise(function (resolve, reject) {
            var objectStore = database.transaction(store, 'readwrite').objectStore(store);
            var putRequest = objectStore.put(object.value, object.key);
            putRequest.onsuccess = function (event) { return resolve(); };
            putRequest.onerror = function (event) { return reject(event); };
        });
    };
    SecurityHandler.prototype.getObject = function (database, store, key) {
        return new Promise(function (resolve, reject) {
            var objectStore = database.transaction(store, 'readonly').objectStore(store);
            var getRequest = objectStore.get(key);
            getRequest.onsuccess = function (event) {
                resolve(event.target.result);
            };
            getRequest.onerror = function (event) { return reject(event); };
        });
    };
    SecurityHandler.prototype.deleteObject = function (database, store, key) {
        return new Promise(function (resolve, reject) {
            var objectStore = database.transaction(store, 'readwrite').objectStore(store);
            var deleteRequest = objectStore.delete(key);
            deleteRequest.onsuccess = function (event) {
                resolve(event.target.result);
            };
            deleteRequest.onerror = function (event) { return reject(event); };
        });
    };
    SecurityHandler.prototype.initKeys = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, importedPassword, tmpKey, exportedTmpKey, importedTmpKey, masterKeyTmp, masterKeyExported, importedMasterKey, authKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        salt = this.textEncoder.encode(username);
                        return [4 /*yield*/, crypto.subtle.importKey('raw', this.textEncoder.encode(password), 'PBKDF2', false, ['deriveKey'])];
                    case 1:
                        importedPassword = _a.sent();
                        return [4 /*yield*/, crypto.subtle.deriveKey({
                                name: 'PBKDF2',
                                salt: salt,
                                iterations: this.numIterations,
                                hash: 'SHA-256'
                            }, importedPassword, {
                                name: 'AES-GCM',
                                length: this.derivedKeyLengthBits
                            }, true, ['encrypt'])];
                    case 2:
                        tmpKey = _a.sent();
                        return [4 /*yield*/, crypto.subtle.exportKey('raw', tmpKey)];
                    case 3:
                        exportedTmpKey = _a.sent();
                        return [4 /*yield*/, crypto.subtle.importKey('raw', exportedTmpKey, 'PBKDF2', false, ['deriveKey'])];
                    case 4:
                        importedTmpKey = _a.sent();
                        return [4 /*yield*/, crypto.subtle.deriveKey({
                                name: 'PBKDF2',
                                salt: salt,
                                iterations: this.numIterations,
                                hash: 'SHA-256'
                            }, importedTmpKey, {
                                name: 'AES-GCM',
                                length: this.derivedKeyLengthBits
                            }, true, ['encrypt', 'decrypt'])];
                    case 5:
                        masterKeyTmp = _a.sent();
                        return [4 /*yield*/, crypto.subtle.exportKey('raw', masterKeyTmp)];
                    case 6:
                        masterKeyExported = _a.sent();
                        return [4 /*yield*/, crypto.subtle.importKey('raw', masterKeyExported, 'PBKDF2', false, ['deriveKey'])];
                    case 7:
                        importedMasterKey = _a.sent();
                        return [4 /*yield*/, crypto.subtle.deriveKey({
                                name: 'PBKDF2',
                                salt: salt,
                                iterations: this.numIterations,
                                hash: 'SHA-256'
                            }, importedTmpKey, {
                                name: 'AES-GCM',
                                length: this.derivedKeyLengthBits
                            }, true, ['encrypt'])
                            //const authentificationKey = new Uint8Array(await crypto.subtle.exportKey('raw', authKey))
                        ];
                    case 8:
                        authKey = _a.sent();
                        //const authentificationKey = new Uint8Array(await crypto.subtle.exportKey('raw', authKey))
                        this.saveKeys(importedMasterKey, authKey);
                        return [2 /*return*/];
                }
            });
        });
    };
    SecurityHandler.prototype.generateRandomString = function (length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };
    SecurityHandler.stringToArrayBuffer = function (str) {
        var buf = new ArrayBuffer(str.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    };
    return SecurityHandler;
}());
export { SecurityHandler };
